import { css } from '@emotion/react'

export const dropdownContainer = css`
  & > * {
    width: 100%;
  }
`

export const topFields = theme => css`
  display: flex;
  margin-left: -${theme.spacing[7]};
  margin-right: -${theme.spacing[7]};

  & > * {
    flex-basis: 50%;
    max-width: 50% !important;
    padding-left: ${theme.spacing[7]};
    padding-right: ${theme.spacing[7]};
  }
`

export const fullWidth = css`
  min-width: 100%;
`
